import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { useSEO } from "@/lib/seo";

export default function NotFound() {
  useSEO({ title: "Page not found | Disposable Smart Labels", description: "The page you are looking for could not be found." });
  return (
    <div data-testid="page-404" className="container-x section text-center">
      <p className="eyebrow">404</p>
      <h1 className="h1 mt-4">Page not found.</h1>
      <p className="lead mt-5 max-w-xl mx-auto">
        The page you&apos;re looking for has moved or no longer exists. Let&apos;s get you
        back on track.
      </p>
      <Link to="/" className="btn-primary mt-8 mx-auto" data-testid="404-home">
        Back to homepage <ArrowRight className="h-4 w-4" />
      </Link>
    </div>
  );
}
